import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';

import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {validateEmpty} from '../../../../global/custom-validate';
import {language} from '../../../../language/vn';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {BsModalService} from 'ngx-bootstrap/modal';
import {DatePipe} from '@angular/common';
import {YeuCauService} from '../../../../service/yeucau/service-yeucau';
import {YeuCauFileService} from '../../../../service/yeucau/service-yeucaufile';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {SelectStaffComponent} from '../../../ui/selectstaff/selectstaff.component';
import {Router} from '@angular/router';
import {FormatService} from '../../../../service/format/service-format';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';
@Component({
  templateUrl: './soanyeucau.component.html',

})
export class SoanYeuCauComponent implements OnInit, AfterViewInit {
  @ViewChild(SelectStaffComponent)
  public uiSelectStaff: SelectStaffComponent;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public submitValidate = false;
  public srChuDe: string = '';
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  public staffSelectList: Object[];
  public selectedList: Object[];
  public dateCurrent: Date ;
  public xem: number = 1;
  constructor(
    public yeuCauService: YeuCauService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public yeuCauFileService: YeuCauFileService,
    public bsModalService: BsModalService,
    public datepipe: DatePipe,
    public router: Router,
    public formatService: FormatService,
    private rolePermissionService: RolePermissionService
  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
  }
  ngOnInit(): void {
    this.rolePermissionService.checkNavByCode(Sessioncommand.staffId, 'YCADD').subscribe( x => {
      if (x === false)
        this.rolePermissionService.redirectAccesDenied();
    });
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      chuDe: new FormControl(),
      thoiGianHoanThanh: new FormControl(),
      choThamKhao: new FormControl(1),
      noiDung: new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      id: ['', Validators.nullValidator],
      chuDe: ['' , Validators.compose([validateEmpty]) ],
      thoiGianHoanThanh: ['', Validators.nullValidator],
      noiDung: ['', Validators.nullValidator],
      choThamKhao: ['1', Validators.nullValidator]
    });
    this.uploadUrl= this.yeuCauFileService.urlUpload;
    this.deleteUrl= this.yeuCauFileService.urlDelete;
    this.staffSelectList = [];
    this.selectedList = [];
  }
  get f() { return this.frmGroup.controls; }

  createItem ()
  {

          this.frmGroup.value.thoiGianHoanThanh = this.datepipe.transform(this.dateCurrent, 'dd/MM/yyyy');;
          this.frmGroup.value.maNguoiChuTri = Sessioncommand.staffId;
          this.frmGroup.value.trangThai= this.isEdit == true ? 1 : 0;
          this.frmGroup.value.choThamKhao= (this.frmGroup.value.choThamKhao ==true || this.frmGroup.value.choThamKhao ==1 )? 1: 0;
          let arrStaff: string = this.uiSelectStaff.selected.join();
          this.yeuCauService.add(arrStaff, this.frmGroup.value).subscribe(
            {    next: (data) => {
                this.uploadFileComponent.id = data.id;
                this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
                this.toastr.success(this.isEdit==false?language.add_success_record: language.send_success_record, language.message);
                Sessioncommand.notification = true;
                Sessioncommand.giaiQuyetSuVuStatus = 0;
                if(this.isEdit === true)
                  this.router.navigate(['/giaiquyetsuvu/qlsuvu'], {  queryParams: {  ty: 'ycg' } });
                else
                  this.router.navigate(['/giaiquyetsuvu/qlsuvu'], {  queryParams: {  ty: 'ycs' } });
              },
              error: error => {
                this.toastr.error(language.error, language.message);
              }
            });
  }
  public showGroup()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null)
      {
        for (let i = 0; i < result.length; i++) {

          if(this.staffSelectList.some(e => e["id"] === result[i].id)==false && result[i].id !== Sessioncommand.staffId) {
            this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
            this.selectedList= [...this.selectedList, result[i].id];
          }
        }
      }
    });
  }

  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;

      this.createItem();
  }


}

